document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".flex-layout.uitklap_secties-layout").forEach((layout) => {
        const items = [...layout.querySelectorAll(".uitklap-item")];
        if (!items.length) return;

        const setOpen = (item, open) => {
            item.classList.toggle("is-open", open);
            item.querySelector(".uitklap-toggle")?.setAttribute("aria-expanded", String(open));

            const panel = item.querySelector(".uitklap-panel");
            if (panel) panel.inert = !open;
        };

        items.forEach((item) => {
            setOpen(item, false);

            item.querySelector(".uitklap-toggle")?.addEventListener("click", () => {
                const isOpen = item.classList.contains("is-open");
                items.forEach((other) => setOpen(other, false));
                if (!isOpen) setOpen(item, true);
            });
        });

        setOpen(items[0], true);
    });
});
